export class SeenTracker {
	private data: any;

	constructor(private readonly storageKey: string | null) {
		this.data = this._loadFromStorage();
	}

	_loadFromStorage() {
		if (this.storageKey === null) {
			return {};
		}
		const storedData = localStorage.getItem(this.storageKey);
		return storedData ? JSON.parse(storedData) : {};
	}

	_saveToStorage() {
		if (this.storageKey === null) {
			return;
		}

		localStorage.setItem(this.storageKey, JSON.stringify(this.data));
	}

	add(item: string) {
		const parts = item.split('.');
		let current = this.data;

		for (const part of parts) {
			if (!current[part]) {
				current[part] = { _seen: false };
			}
			current = current[part];
		}

		this._saveToStorage();
	}

	isUnseen(item: string) {
		const parts = item.split('.');
		let current = this.data;

		for (const part of parts) {
			if (!current[part]) {
				return true;
			}
			if (!current[part]._seen) {
				return true;
			}
			current = current[part];
		}

		return false;
	}

	markAsSeen(item: string) {
		const parts = item.split('.');
		let current = this.data;

		for (const part of parts) {
			if (!current[part]) {
				current[part] = { _seen: true };
			} else {
				current[part]._seen = true;
			}
			current = current[part];
		}

		this._saveToStorage();
	}
}
